export const palette = {
  dark: [0.55, 0.6],
  light: [0.26, 0.93],
};

export function hashStr(input) {
  const str = input.toLowerCase();
  let hash = 0,
    i,
    chr;
  if (str.length === 0) return hash;
  for (i = 0; i < str.length; i++) {
    chr = str.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
}

export function hsv2rgb(h, s, v) {
  let r, g, b;
  if (h && s === undefined && v === undefined) {
    s = h.s;
    v = h.v;
    h = h.h;
  }
  const i = Math.floor(h * 6);
  const f = h * 6 - i;
  const p = v * (1 - s);
  const q = v * (1 - f * s);
  const t = v * (1 - (1 - f) * s);
  switch (i % 6) {
    case 0:
      r = v;
      g = t;
      b = p;
      break;
    case 1:
      r = q;
      g = v;
      b = p;
      break;
    case 2:
      r = p;
      g = v;
      b = t;
      break;
    case 3:
      r = p;
      g = q;
      b = v;
      break;
    case 4:
      r = t;
      g = p;
      b = v;
      break;
    case 5:
      r = v;
      g = p;
      b = q;
      break;
  }
  const rgb = [Math.floor(r * 255), Math.floor(g * 255), Math.floor(b * 255)];

  function componentToHex(c) {
    const hex = c.toString(16);
    return hex.length === 1 ? '0' + hex : hex;
  }

  return '#' + rgb.map(componentToHex).join('');
}

export function pctToColor(pct, s, v) {
  return hsv2rgb(pct, s, v);
}

export function colorForString(str, dark = true) {
  const fudge = 50;
  const hash = hashStr(str) + fudge;
  const pct = Math.abs(Math.sin(hash)) * 100;
  if (dark) {
    return pctToColor(pct, palette.dark[0], palette.dark[1]);
  } else {
    return pctToColor(pct, palette.light[0], palette.light[1]);
  }
}

export function randomColors(total, s, v) {
  s = s || 0.5;
  v = v || 0.5;
  const r = []; // hold the generated colors
  for (let x = 0; x < total; x++) {
    r.push(hsv2rgb(x / total, s, v)); // you can also alternate the saturation and value for even more contrast between the colors
  }
  return r;
}

export function hexToRGBA(hex, alpha = 1) {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
}

export function getDarkColor(pct) {
  return pctToColor(pct, palette.dark[0], palette.dark[1]);
}

export function getLightColor(pct) {
  return pctToColor(pct, palette.light[0], palette.light[1]);
}

//

export const hashCode = (s) => {
  if (!s) {
    return 0;
  }

  let h = 0;
  const l = s.length;
  let i = 0;
  if (l > 0) while (i < l) h = ((h << 5) - h + s.charCodeAt(i++)) | 0;
  return h;
};

export const getLetters = (name) =>
  (name || '')
    .trim()
    .split(/\s+/)
    .map((v) => v[0] || '')
    .filter((v) => /[a-zA-Z]/.exec(v))
    .join('')
    .toUpperCase()
    .substring(0, 2) || '';

export const getColorHash = (name) => {
  return Math.abs(Math.sin(hashCode(name)));
};

export const useBorderStyle = (name, color = null) => {
  const hash = color || getColorHash(name);
  const borderColor = getDarkColor(hash);

  return {
    borderLeftColor: borderColor,
    borderLeftWidth: 4,
    borderLeftStyle: 'solid',
  };
};

// Bright colours. Not accessible, use only for icons / decorations
export const baseColors = [
  '#F56200', //Tangerine
  '#FF9B28', //Orange
  '#FFC300', //Sunflower
  '#E22945', //Crimson
  '#FF5585', //Pink
  '#2CA06A', //Emerald
  '#37C76C', //Green
  '#00C5BB', //Teal
  '#8750E4', //Violet
  '#4012CE', //Indigo
  '#2C7CF9', //Sky Blue
];

export const colorNames = [
  'Tangerine',
  'Orange',
  'Sunflower',
  'Crimson',
  'Pink',
  'Emerald',
  'Green',
  'Teal',
  'Violet',
  'Indigo',
  'Sky Blue',
];

// export const baseColorData = [
//   { value: '#F56200', label: 'Tangerine' },
//   { value: '#FF9B28', label: 'Orange' },
//   { value: '#FFC300', label: 'Sunflower' },
//   { value: '#E22945', label: 'Crimson' },
//   { value: '#FF5585', label: 'Pink' },
//   { value: '#2CA06A', label: 'Emerald' },
//   { value: '#37C76C', label: 'Green' },
//   { value: '#00C5BB', label: 'Teal' },
//   { value: '#8750E4', label: 'Violet' },
//   { value: '#4012CE', label: 'Indigo' },
//   { value: '#2C7CF9', label: 'Sky Blue' },
// ];

// Accessible colors for text, can be used over lightBgColor
export const darkTextColors = [
  '#B34700', // Tangerine
  '#B36B00', // Orange
  '#C18503', // Sunflower
  '#C8011F', // Crimson
  '#C64F71', // Pink
  '#1A8453', // Emerald
  '#25974E', // Green
  '#008078', // Teal
  '#5D3A99', // Violet
  '#1E2879', // Indigo
  '#245ED3', // Sky Blue
];

// Softer versions of base colours, slightly darker than lightBgColors
export const borderColors = [
  '#FF9B5F', // Tangerine
  '#FFC65C', // Orange
  '#FFE47B', // Sunflower
  '#F4A6B2', // Crimson
  '#FFF6F9', // Pink
  '#89D8B3', // Emerald
  '#8EEC8B', // Green
  '#8BE5E2', // Teal
  '#B7A4EF', // Violet
  '#959BFF', // Indigo
  '#6CA8FF', // Sky Blue
];

// Lightest versions of base colours, suitable for backgrounds with DarkText on top
export const lightBgColors = [
  '#FFEFE3', // Tangerine
  '#FFF3E0', // Orange
  '#FFF9E3', // Sunflower
  '#FFE8EB', // Crimson
  '#FFE5EF', // Pink
  '#D7FFEC', // Emerald
  '#DDFFDC', // Green
  '#E6FAF9', // Teal
  '#F0E8FC', // Violet
  '#E2E9FF', // Indigo
  '#E6F0FA', // Sky Blue
];

// Base colours, made accessible as backgrounds with white text on top
export const baseBgColors = [
  '#E8640D', // Tangerine
  '#D9801A', // Orange
  '#BF8C01', // Sunflower
  '#D71532', // Crimson
  '#FE487B', // Pink
  '#2CA06A', // Emerald
  '#15AC4C', // Green
  '#009089', // Teal
  '#7A30F6', // Violet
  '#3F0ED3', // Indigo
  '#075EE5', // Sky Blue
];

// Helper to get a number from a string (for hashing)
export const stringToNumber = (str: string, max: number) => {
  const hash = hashCode(str);
  return Math.abs(hash) % max;
};
